import { render, staticRenderFns } from "./PreviewProducts.vue?vue&type=template&id=2e4e2142&scoped=true&"
import script from "./PreviewProducts.vue?vue&type=script&lang=js&"
export * from "./PreviewProducts.vue?vue&type=script&lang=js&"
import style0 from "./PreviewProducts.vue?vue&type=style&index=0&id=2e4e2142&prod&lang=css&"
import style1 from "./PreviewProducts.vue?vue&type=style&index=1&id=2e4e2142&prod&scoped=true&lang=css&"
import style2 from "./PreviewProducts.vue?vue&type=style&index=2&id=2e4e2142&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4e2142",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VApp,VBtn,VCard,VChip,VCol,VDivider,VIcon,VList,VListItem,VListItemContent,VListItemTitle,VMain,VRow,VTextField})
